import axiosConfig from "./axiosConfig";

export interface AxpoCounterInvoiceBatchFileRef {
  s3Key: string;
  fileName: string;
}

export interface AxpoCounterInvoiceBatchRequest {
  files: AxpoCounterInvoiceBatchFileRef[];
}

export interface AxpoCounterInvoiceBatchResponse {
  operationKey: string;
  status: "pending" | "running" | "completed" | "failed";
  siteId: string;
  filesCount: number;
}

export interface AxpoCounterInvoiceBatchFileResult {
  fileName: string;
  format: "pdf" | "xlsx";
  siteId: string;
  siteName?: string;
  mpan?: string;
  exportGridConnectionId?: string;
  month?: string;
  pairingId?: string;
  // XLSX-only
  readingsCount?: number;
  readingsProcessed?: boolean;
  sellerFilesCreated?: number;
  buyerFilesCreated?: number;
  // PDF-only
  lineItemsCount?: number;
}

export interface AxpoCounterInvoiceBatchFileError {
  fileName: string;
  format: "pdf" | "xlsx";
  siteId: string;
  siteName?: string;
  mpan?: string;
  month?: string;
  error: string;
}

export interface AxpoCounterInvoiceBatchOperationResult {
  filesProcessed: number;
  filesErrored: number;
  fileResults: AxpoCounterInvoiceBatchFileResult[];
  errors: AxpoCounterInvoiceBatchFileError[];
  axpoCounterInvoices: Record<string, unknown>[];
}

export interface AxpoCounterInvoiceBatchUploadUrlRequest {
  fileName: string;
  contentType: string;
}

export interface AxpoCounterInvoiceBatchUploadUrlResponse {
  url: string;
  s3Key: string;
  fileGuid: string;
}

export const getAxpoCounterInvoiceBatchUploadUrl = async (
  authToken: string,
  body: AxpoCounterInvoiceBatchUploadUrlRequest
): Promise<AxpoCounterInvoiceBatchUploadUrlResponse> => {
  const { data } = await axiosConfig.post(
    "/admin/axpo-counter-invoice/batch/upload-url",
    body,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

const createAxpoCounterInvoiceBatch = async (
  authToken: string,
  body: AxpoCounterInvoiceBatchRequest
): Promise<AxpoCounterInvoiceBatchResponse> => {
  const { data } = await axiosConfig.post(
    "/admin/axpo-counter-invoice/batch",
    body,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default createAxpoCounterInvoiceBatch;
